// Shared visual tokens for floating map chrome (zoom pill, expand/close buttons,
// popup close, carousel nav buttons): a translucent-white surface + the elevation
// used across DestinationCard badges and the Carousel.

export const MAP_CHROME_SURFACE = "bg-white/80 backdrop-blur-[2px] shadow-chip";

/** Interactive core shared by every chrome button — standalone round buttons and zoom-pill segments. */
export const MAP_CHROME_BUTTON =
  "flex items-center justify-center text-neutral-900 transition-colors hover:bg-white active:bg-neutral-50";

/** A 28px round button on the map surface (popup close). */
export const MAP_CHROME_ROUND_BUTTON = `size-7 rounded-full ${MAP_CHROME_BUTTON} ${MAP_CHROME_SURFACE}`;

/** A 40px round button on the map surface (zoom / fullscreen controls). */
export const MAP_CHROME_ROUND_BUTTON_LG = `size-10 rounded-full ${MAP_CHROME_BUTTON} ${MAP_CHROME_SURFACE}`;
